import { render, staticRenderFns } from "./main-header-langs.vue?vue&type=template&id=617c7c13&"
import script from "./main-header-langs.ts?vue&type=script&lang=ts&"
export * from "./main-header-langs.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports